import "./App.css";
import React, { useEffect } from "react";
import Home from "./pages/Home";
import About from "./pages/About";

// source : https://herotofu.com/solutions/guides/react-contact-form

function App() {
  // You can skip useEffect if you're not using TailwindCSS
  // Otherwise, for the production usage refer to https://tailwindcss.com/docs/installation
  useEffect(() => {
    if (document) {
      const stylesheet = document.createElement("link");
      stylesheet.rel = "stylesheet";
      stylesheet.href = "https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css";

      document.head.appendChild(stylesheet);
    }
  }, []);

  return (
      <Home />
  );
}

export default App;